import React, { ReactElement, ReactNode } from "react";
import Head from "next/head";
import { useModal } from "@hooks/useModalContext";
import dynamic from "next/dynamic";
import styles from "./copiercostsLayouts.module.scss";
import Mobile from "@components/shared/blogPost/sideWidget/mobile";

const CloseIcon = dynamic(() => import("@components/svg/closeIcon"));
const TermsAndConditions = dynamic(
    () => import("@components/shared/legal/termsAndConditions"),
);
const PrivacyPolicy = dynamic(
    () => import("@components/shared/legal/privacyPolicy"),
);
const Modal = dynamic(() => import("@components/shared/modal"));
const MainLayout = dynamic(() => import("@components/copiercosts/mainLayout"));

export default function CopierCostsWrapper({
    children,
}: {
    children: ReactNode;
}): ReactElement {
    const { modal, closeModal } = useModal();

    const handleClose = () => {
        closeModal();
    };

    const { active: modalActive, content: modalContent } = modal;

    const getModalContent = () => {
        switch (modalContent) {
            case "privacy":
                return (
                    <PrivacyPolicy
                        category="Copier Costs"
                        domain="CopierCosts.com"
                    />
                );
            case "terms":
                return (
                    <TermsAndConditions
                        category="Copier Costs"
                        domain="CopierCosts.com"
                    />
                );
            case "sideWidget":
                return <Mobile />;
            default:
                return null;
        }
    };

    return (
        <>
            <Head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"
                    rel="stylesheet"
                />
            </Head>

            <div style={{ fontFamily: `'Roboto', sans-serif` }}>
                <div className={styles["mainDigitalCopierBg"]}>
                    <MainLayout>{children}</MainLayout>
                </div>
                <Modal
                    onClose={handleClose}
                    active={modalActive}
                    closeIcon={<CloseIcon />}
                    backdropClosable
                    modalStyles={{
                        display: "flex",
                        flexDirection: "column",
                        maxHeight:
                            modalContent === "sideWidget" ? "80vh" : "100%",
                    }}
                    modalClassName="h-[90vh] rounded"
                    bodyStyles={{ overflowY: "scroll" }}
                    width={900}
                    header={
                        modalContent === "privacy"
                            ? "Privacy Policy"
                            : modalContent === "terms"
                            ? "Terms and Conditions"
                            : modalContent === "sideWidget"
                            ? "Contents"
                            : undefined
                    }
                >
                    {getModalContent()}
                </Modal>
            </div>
        </>
    );
}
